import MountainLogo from "./images/mountain.png"
import TentLogo from "./images/tent.png"
import RiverLogo from "./images/river.png"


const TheData = [
    {
        id: 1,
        title: "Mount Fuji",
        location: "Japan",
        googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
        startDate: "12 Jan, 2021",
        endDate: "24 Jan, 2021",
        description: "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
        imageUrl: MountainLogo
    },

    {
        id: 2,
        title: "Sydney Opera House",
        location: "AUSTRALIA",
        googleMapsUrl: "https://www.google.com/maps/place/Sydney+Opera+House/@-33.8567844,151.2152967,15z/data=!4m5!3m4!1s0x0:0x3133f8d75a1ac251!8m2!3d-33.8567844!4d151.2152967",
        startDate: "27 May, 2021",
        endDate: "8 Jun, 2021",
        description: "The Sydney Opera House is a multi-venue performing arts centre in Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings.",
        imageUrl: TentLogo
    },

    {
        id: 3,
        title: "Geirangerfjord",
        location: "NORWAY",
        googleMapsUrl: "https://www.google.com/maps/place/Geirangerfjord,+Stranda+Municipality,+Norway/data=!4m2!3m1!1s0x46169d427b268c51:0xb8c99540dcc397fe?sa=X&ved=2ahUKEwiT44fSwYz4AhXgSzABHcSKCpcQ8gF6BAhXEAE",
        startDate: "01 Oct, 2021",
        endDate: "18 Nov, 2021",
        description: "The Geiranger Fjord is a fjord in the Sunnmore region of More og Romsdal county, Norway. It is located entirely in the Stranda Municipality",
        imageUrl: RiverLogo
    }
]

export { TheData as default } 